import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { useLocation } from "react-router-dom";
import { prefetchConversationMessages, prefetchConversations } from '../services/conversationsService';
import {
  FiMail,
  FiBell,
  FiSearch,
  FiHeart,
  FiMenu,
  FiUser,
  FiLogOut,
  FiHome,
  FiCalendar,
  FiPause,
  FiShield,
  FiChevronRight,
  FiArrowUpRight
} from 'react-icons/fi';

import logo from '../IMAGES/nidologo.png';

export default function Header() {
  const { isAuthenticated, logout, user } = useAuth();
  const navigate = useNavigate();

  const [openUserMenu, setOpenUserMenu] = useState(false);
  const [openMegaMenu, setOpenMegaMenu] = useState(null);
  const [openMobileMenu, setOpenMobileMenu] = useState(false);
  
  const location = useLocation();

const isDevelopmentDetail =
  location.pathname.startsWith("/desarrollo/");

  const closeTimeout = useRef(null);

  useEffect(() => {
    setOpenMobileMenu(false);
    setOpenMegaMenu(null);
    setOpenUserMenu(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = openMobileMenu ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [openMobileMenu]);

  useEffect(() => {
    if (!isAuthenticated) return undefined;
    const warmMessages = () => {
      prefetchConversations().then((conversations) => {
        if (conversations) prefetchConversationMessages(conversations);
      });
    };
    const timer = window.setTimeout(warmMessages, 900);
    return () => window.clearTimeout(timer);
  }, [isAuthenticated]);

  useEffect(() => {
    const desktop = window.matchMedia('(min-width: 901px)');
    const closeOnDesktop = event => {
      if (event.matches) setOpenMobileMenu(false);
    };
    const closeOnEscape = event => {
      if (event.key === 'Escape') setOpenMobileMenu(false);
    };
    desktop.addEventListener('change', closeOnDesktop);
    window.addEventListener('keydown', closeOnEscape);
    return () => {
      desktop.removeEventListener('change', closeOnDesktop);
      window.removeEventListener('keydown', closeOnEscape);
    };
  }, []);

  const openMega = (type) => {
    if (closeTimeout.current) clearTimeout(closeTimeout.current);
    setOpenMegaMenu(type);
  };

  const closeMega = () => {
    closeTimeout.current = setTimeout(() => {
      setOpenMegaMenu(null);
    }, 120);
  };

  const handleLogout = () => {
    logout();
    setOpenUserMenu(false);
    navigate('/');
  };

  const handlePublish = () => {
    if (!isAuthenticated) {
      navigate('/login', { state: { from: { pathname: '/publicar', search: '' } } });
    } else {
      navigate('/publicar');
    }
  };

  return (
    <>
    <HeaderWrapper overlay={isDevelopmentDetail}>
      <Inner>

        <Logo to="/">
          <LogoImg src={logo} alt="NIDO" />
        </Logo>

        <MobileActions>
          <MobileHeaderPublish type="button" onClick={handlePublish}>Publicar</MobileHeaderPublish>
          <MobileMenuButton
            type="button"
            aria-label={openMobileMenu ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={openMobileMenu}
            onClick={() => setOpenMobileMenu(value => !value)}
          >
            {openMobileMenu ? '×' : <FiMenu />}
          </MobileMenuButton>
        </MobileActions>

        <NavArea onMouseLeave={closeMega}>
          <Nav>

            <NavItemWrapper onMouseEnter={() => openMega('comprar')}>
              <NavItem to="/buscar?operation=venta">Comprar</NavItem>
            </NavItemWrapper>

            <NavItemWrapper onMouseEnter={() => openMega('alquilar')}>
              <NavItem to="/buscar?operation=alquiler">Alquilar</NavItem>
            </NavItemWrapper>

            <NavItemWrapper onMouseEnter={() => openMega('desarrollos')}>
              <NavItem to="/desarrollos">Desarrollos</NavItem>
            </NavItemWrapper>

            <NavItemWrapper onMouseEnter={() => openMega('cuyo')}>
              <NavItem to="/explorar-cuyo">Explorar Cuyo</NavItem>
            </NavItemWrapper>

            <NavItemWrapper>
              <VacationNav to="/vacaciones">Vacaciones <span>↗</span></VacationNav>
            </NavItemWrapper>

          </Nav>

          {openMegaMenu && (
            <MegaMenu onMouseEnter={() => clearTimeout(closeTimeout.current)}>
              <MegaInner $rental={openMegaMenu === 'alquilar'}>

                {openMegaMenu === 'comprar' && (
                  <>
                    <Column>
                      <ColumnTitle>Tipo de propiedad</ColumnTitle>

                      <MenuLink to="/buscar?operation=venta&type=casa">
                        Casas
                      </MenuLink>

                      <MenuLink to="/buscar?operation=venta&type=departamento">
                        Departamentos
                      </MenuLink>

                      <MenuLink to="/buscar?operation=venta&type=lote">
                        Terrenos
                      </MenuLink>

                      <MenuLink to="/buscar?operation=venta&type=quinta">
                        Quintas
                      </MenuLink>

                      <MenuLink to="/buscar?operation=venta&type=local_comercial">
                        Locales comerciales
                      </MenuLink>

                      <MenuLink to="/buscar?operation=venta">
                        Ver todas las propiedades →
                      </MenuLink>

                    </Column>

                    <Column>
                      <ColumnTitle>Provincias de Cuyo</ColumnTitle>
                      <MenuLink to="/buscar?operation=venta&province=mendoza">Mendoza</MenuLink>
                      <MenuLink to="/buscar?operation=venta&province=san_juan">San Juan</MenuLink>
                      <MenuLink to="/buscar?operation=venta&province=san_luis">San Luis</MenuLink>
                      <MenuLink to="/buscar?operation=venta">Todo Cuyo →</MenuLink>
                    </Column>

                    <Column><ColumnTitle>Zonas destacadas</ColumnTitle>
                      <MenuLink to="/buscar?operation=venta&province=mendoza&department=Capital">Mendoza Capital</MenuLink>
                      <MenuLink to="/buscar?operation=venta&province=san_juan&department=Rivadavia">Rivadavia, San Juan</MenuLink>
                      <MenuLink to="/buscar?operation=venta&province=san_luis&department=Juan%20Mart%C3%ADn%20de%20Pueyrred%C3%B3n">San Luis Capital</MenuLink>
                    </Column>
                  </>
                )}

                {openMegaMenu === 'alquilar' && (
                  <>
                    <Column>
                      <ColumnTitle>Tipo de propiedad</ColumnTitle>
                      <MenuLink to="/buscar?operation=alquiler&type=casa">Casas</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler&type=departamento">Departamentos</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler&type=quinta">Quintas</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler&type=local_comercial">Locales comerciales</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler">Ver todos los alquileres →</MenuLink>
                    </Column>
                    <Column>
                      <ColumnTitle>Modalidad</ColumnTitle>
                      <MenuLink to="/buscar?operation=alquiler">Alquiler tradicional</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler_temporal">Alquiler temporal</MenuLink>
                      <MenuLink to="/vacaciones">Alquiler vacacional</MenuLink>
                      <ColumnTitle>Buscar en Cuyo</ColumnTitle>
                      <MenuLink to="/buscar?operation=alquiler&province=mendoza">Mendoza</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler&province=san_juan">San Juan</MenuLink>
                      <MenuLink to="/buscar?operation=alquiler&province=san_luis">San Luis</MenuLink>
                      <MenuLink to="/explorar-cuyo">Explorar por ubicación →</MenuLink>
                    </Column>
                    <VacationFeature to="/vacaciones">
                      <VacationTop><VacationEyebrow>ESCAPADAS · CUYO</VacationEyebrow><VacationTag>CURADO POR NIDO</VacationTag></VacationTop>
                      <VacationTitle>Las vacaciones empiezan cuando encontrás tu lugar.</VacationTitle>
                      <VacationCopy>Casas, cabañas y refugios para escaparte a la montaña, el vino y las sierras.</VacationCopy>
                      <VacationAction><span><small>ESCAPATE A CUYO</small>Encontrá tus próximas vacaciones</span><b>↗</b></VacationAction>
                    </VacationFeature>
                  </>
                )}

                {openMegaMenu === 'desarrollos' && (
                  <>
                    <Column>
                      <ColumnTitle>Proyectos</ColumnTitle>

                      <MenuLink to="/desarrollos">
                        Nuevos desarrollos
                      </MenuLink>

                    <MenuLink to="/desarrollos/barrios-privados">
  Barrios privados
</MenuLink>

<MenuLink to="/desarrollos/loteos">
  Loteos
</MenuLink>
                    </Column>

                    <Column>
                      <ColumnTitle>Inversión</ColumnTitle>

                      <MenuLink to="/desarrollos/preventa">
                        Preventa
                      </MenuLink>

                      <MenuLink to="/desarrollos/en-construccion">
                        En construcción
                      </MenuLink>

                      <MenuLink to="/desarrollos/oportunidades">
                        Oportunidades
                      </MenuLink>
                    </Column>

                    <Column>
                      <ColumnTitle>Zonas</ColumnTitle>

                      <MenuLink to="/desarrollos/mendoza">
                        Mendoza
                      </MenuLink>

                      <MenuLink to="/desarrollos/san-juan">
                        San Juan
                      </MenuLink>

                      <MenuLink to="/desarrollos/san-luis">
                        San Luis
                      </MenuLink>
                    </Column>
                  </>
                )}

                {openMegaMenu === 'cuyo' && (
                  <>
                    <Column>
                      <ColumnTitle>Provincias</ColumnTitle>

                      <MenuLink to="/buscar?province=mendoza">
                        Mendoza
                      </MenuLink>

                      <MenuLink to="/buscar?province=san_juan">
                        San Juan
                      </MenuLink>

                      <MenuLink to="/buscar?province=san_luis">
                        San Luis
                      </MenuLink>
                    </Column>

                    <Column>
                      <ColumnTitle>Descubrir el territorio</ColumnTitle>

                      <MenuLink to="/explorar-cuyo">
                        Explorar Cuyo por zonas
                      </MenuLink>

                      <MenuLink to="/vacaciones">
                        Escapadas y temporarios
                      </MenuLink>

                      <MenuLink to="/desarrollos">
                        Invertir en la región
                      </MenuLink>
                    </Column>

                    <Column>
                      <ColumnTitle>Una manera de vivir</ColumnTitle>

                      <MenuLink to="/vivir-cuyo/vino-y-valle-de-uco">
                        Vino y Valle de Uco
                      </MenuLink>

                      <MenuLink to="/vivir-cuyo/montana-y-aventura">
                        Montaña y aventura
                      </MenuLink>

                      <MenuLink to="/vivir-cuyo/sierras-y-naturaleza">
                        Sierras y naturaleza
                      </MenuLink>
                    </Column>
                  </>
                )}

              </MegaInner>
            </MegaMenu>
          )}
        </NavArea>

        <Right>

          <IconLink to="/buscar">
            <FiSearch />
            <HoverLabel>Buscar</HoverLabel>
          </IconLink>

          {isAuthenticated && (
            <>
              <IconLink
                to="/mensajes"
                onPointerEnter={() => prefetchConversations().then((items) => items && prefetchConversationMessages(items))}
                onFocus={() => prefetchConversations().then((items) => items && prefetchConversationMessages(items))}
                onTouchStart={() => prefetchConversations().then((items) => items && prefetchConversationMessages(items))}
              >
                <FiMail />
                <HoverLabel>Mensajes</HoverLabel>
              </IconLink>

              <IconLink to="/alertas">
                <FiBell />
                <HoverLabel>Alertas</HoverLabel>
              </IconLink>

              <IconLink to="/favoritos">
                <FiHeart />
                <HoverLabel>Mis favoritos</HoverLabel>
              </IconLink>

              <MenuWrapper>
                <MenuButton
                  type="button"
                  aria-label="Abrir menú de usuario"
                  aria-expanded={openUserMenu}
                  onClick={() => setOpenUserMenu(!openUserMenu)}
                >
                  <FiUser />
                </MenuButton>

                {openUserMenu && (
                  <Dropdown>
                    {user?.isAdmin && (
                      <>
                        <DropdownLink to="/admin"><FiShield /> Centro de administración</DropdownLink>
                        <DropdownLink to="/admin/editorial"><FiCalendar /> Campañas editoriales</DropdownLink>
                        <DropdownLink to="/admin/perfiles"><FiUser /> Todos los perfiles</DropdownLink>
                        <DropdownLink to="/admin/publicaciones"><FiPause /> Publicaciones</DropdownLink>
                      </>
                    )}
                    <DropdownLink to="/client">
                      <FiUser /> Mi perfil
                    </DropdownLink>
                    <DropdownLink to="/client#propiedades">
                      <FiHome /> Mis propiedades
                    </DropdownLink>
                    <DropdownLink to="/favoritos">
                      <FiHeart /> Favoritos
                    </DropdownLink>
                    <LogoutButton onClick={handleLogout}>
                      <FiLogOut /> Cerrar sesión
                    </LogoutButton>
                  </Dropdown>
                )}
              </MenuWrapper>
            </>
          )}

          <PublishBtn onClick={handlePublish}>
            Publicar
          </PublishBtn>

          {!isAuthenticated && (
            <LoginBtn to="/login">
              Ingresar
            </LoginBtn>
          )}

        </Right>

      </Inner>

      {openMobileMenu && (
        <MobileMenu
          aria-label="Navegación móvil"
          onClick={event => {
            if (event.target.closest('a')) setOpenMobileMenu(false);
          }}
        >
          <MobilePrimaryLink to="/buscar">Buscar propiedades</MobilePrimaryLink>
          <MobileRichLink to="/buscar?operation=venta">
            <span><strong>Comprar</strong><small>Casas, departamentos y terrenos</small></span>
            <FiChevronRight />
          </MobileRichLink>
          <MobileRichLink to="/buscar?operation=alquiler">
            <span><strong>Alquilar</strong><small>Encontrá tu próximo hogar</small></span>
            <FiChevronRight />
          </MobileRichLink>
          <MobileRichLink to="/buscar?operation=alquiler_temporal">
            <span><strong>Alquiler temporal</strong><small>Viviendas equipadas por semanas o meses</small></span>
            <FiChevronRight />
          </MobileRichLink>
          <MobilePublish type="button" onClick={handlePublish}><span><small>¿TENÉS UNA PROPIEDAD?</small><strong>Publicar tu propiedad</strong></span><FiArrowUpRight /></MobilePublish>
          <MobileVacationLink to="/vacaciones">
            <span>VACACIONES EN CUYO</span>
            <strong>Encontrá tu próxima escapada</strong>
            <small>Cabañas, casas y estadías vacacionales</small>
            <FiChevronRight />
          </MobileVacationLink>
          <MobileMenuCaption>EXPLORAR POR LUGAR</MobileMenuCaption>
          <MobileRichLink to="/explorar-cuyo">
            <span><strong>Explorar Cuyo</strong><small>Recorré Mendoza, San Juan y San Luis por sus zonas</small></span>
            <FiChevronRight />
          </MobileRichLink>
          <MobileSubLinks>
            <MobileLink to="/buscar?province=mendoza">Mendoza</MobileLink>
            <MobileLink to="/buscar?province=san_juan">San Juan</MobileLink>
            <MobileLink to="/buscar?province=san_luis">San Luis</MobileLink>
          </MobileSubLinks>
          <MobileMenuCaption>DESCUBRIR NIDO</MobileMenuCaption>
          <MobileRichLink to="/desarrollos"><span><strong>Desarrollos</strong><small>Proyectos y nuevas oportunidades</small></span><FiChevronRight /></MobileRichLink>
          <MobileRichLink to="/vivir-cuyo"><span><strong>Una manera de vivir</strong><small>Historias, lugares y cultura cuyana</small></span><FiChevronRight /></MobileRichLink>
          {isAuthenticated ? (
            <>
              <MobileDivider />
              {user?.isAdmin && <>
                <MobileLink to="/admin">Centro de administración</MobileLink>
                <MobileLink to="/admin/editorial">Campañas editoriales</MobileLink>
                <MobileLink to="/admin/perfiles">Todos los perfiles</MobileLink>
                <MobileLink to="/admin/publicaciones">Publicaciones</MobileLink>
              </>}
              <MobileLink to="/client">Mi perfil</MobileLink>
              <MobileLink to="/mensajes">Mensajes</MobileLink>
              <MobileLink to="/favoritos">Favoritos</MobileLink>
              <MobileLogout type="button" onClick={handleLogout}>Cerrar sesión</MobileLogout>
            </>
          ) : (
            <MobileLogin to="/login">Ingresar</MobileLogin>
          )}
        </MobileMenu>
      )}
    </HeaderWrapper>
    <HeaderSpacer aria-hidden="true" />
    </>
  );
}

/* ================= ESTILOS ================= */

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  background-color: rgba(250,248,243,0.9);
  border-bottom: 1px solid rgba(43,73,81,0.12);
  box-shadow: 0 10px 36px rgba(42,64,70,0.045);
  backdrop-filter: blur(22px) saturate(130%);
  -webkit-backdrop-filter: blur(22px) saturate(130%);

  z-index: 1000;

  @media (max-width: 900px) {
    box-shadow: 0 1px 0 rgba(0,0,0,0.08);
  }
`;

const HeaderSpacer = styled.div`
  width: 100%;
  height: 104px;
  pointer-events: none;

  @media (max-width: 1100px) {
    height: 92px;
  }

  @media (max-width: 900px) {
    height: 82px;
  }
`;

const Inner = styled.div`
  max-width: 1600px;
  min-height: 104px;
  margin: 0 auto;
  padding: 8px clamp(32px, 4vw, 64px);
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 1100px) {
    min-height: 92px;
    padding: 8px 24px;
  }

  @media (max-width: 900px) {
    min-height: 82px;
    padding: 10px 16px;
  }
`;

const Logo = styled(Link)`
  position: relative;
  display: block;
  flex: 0 0 auto;
  width: 158px;
  height: 82px;
  overflow: hidden;
  cursor: pointer;

  @media (max-width: 1100px) {
    width: 145px;
    height: 76px;
  }

  @media (max-width: 900px) {
    width: 126px;
    height: 64px;
  }
`;

const LogoImg = styled.img`
  position: absolute;
  width: 350px;
  max-width: none;
  height: auto;
  left: -97px;
  top: -64px;
  pointer-events: none;

  @media (max-width: 1100px) {
    width: 325px;
    left: -90px;
    top: -59px;
  }

  @media (max-width: 900px) {
    width: 285px;
    left: -80px;
    top: -52px;
  }
`;

const NavArea = styled.div`
  position: static;

  @media (max-width: 900px) {
    display: none;
  }
`;

const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: clamp(24px, 2.4vw, 38px);
`;

const NavItemWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const NavItem = styled(Link)`
  position: relative;
  padding: 16px 0;
  cursor: pointer;
  font-size: clamp(1.22rem, 1.45vw, 1.38rem);
  font-weight: 500;
  letter-spacing: -0.025em;
  color: #26383e;
  text-decoration: none;
  transition: color 220ms ease;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 7px;
    height: 1.5px;
    background: ${({ theme }) => theme.colors.primary};
    transform: scaleX(0);
    transform-origin: right center;
    transition: transform 260ms cubic-bezier(.2,.7,.2,1);
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:hover::after {
    transform: scaleX(1);
    transform-origin: left center;
  }
`;
const VacationNav = styled(NavItem)`
  display:flex;min-height:42px;align-items:center;gap:8px;padding:0 15px;color:#ad583c;background:rgba(201,111,76,.08);
  border:1px solid rgba(180,95,64,.28);border-radius:999px;font-size:1rem;font-weight:720;
  &::after{display:none;} span{font-size:13px;transition:transform .2s;}
  &:hover{color:#963f26;background:rgba(201,111,76,.14);border-color:rgba(180,95,64,.48);}
  &:hover span{transform:translate(2px,-2px);}
  @media(max-width:1250px){padding:0 12px;font-size:.9rem;}
`;

const MegaMenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;

  background: rgba(252,251,248,0.98);
  padding: 44px 0 48px;

  border-top: 1px solid rgba(43,73,81,0.1);
  border-bottom: 1px solid rgba(43,73,81,0.1);
  box-shadow: 0 28px 70px rgba(42,64,70,0.11);

  z-index: 1500;
`;

const MegaInner = styled.div`
  max-width: 1120px;
  margin: auto;
  padding: 0 32px;

  display: grid;
  grid-template-columns: repeat(3, minmax(0, 240px));
  justify-content: center;
  gap: 72px;

  align-items: start;
  ${({$rental}) => $rental && `
    grid-template-columns: 220px 250px minmax(360px, 420px);
    gap: 44px;
  `}
`;

const Column = styled.div``;

const ColumnTitle = styled.h4`
  margin-bottom: 18px;
  font-weight: 700;
  font-size: 0.78rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #2f7088;
`;

const MenuLink = styled(Link)`
  display: block;
  margin-bottom: 14px;
  font-size: 1.05rem;
  color: #405258;
  text-decoration: none;
  transition: color 180ms ease, transform 180ms ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    transform: translateX(5px);
  }
`;

const VacationFeature = styled(Link)`
  position:relative;display:flex;min-height:285px;overflow:hidden;flex-direction:column;justify-content:flex-end;padding:26px;color:#fff;background:
  linear-gradient(180deg,rgba(24,39,43,.04) 0%,rgba(24,39,43,.28) 42%,rgba(24,39,43,.94) 100%),
  url('https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=900&q=82') center/cover;
  border:1px solid rgba(255,255,255,.2);border-radius:18px;text-decoration:none;box-shadow:0 22px 52px rgba(42,64,70,.18);transition:.35s;
  &::after{content:'';position:absolute;inset:0;border-radius:inherit;box-shadow:inset 0 0 0 1px rgba(255,255,255,.08);pointer-events:none;}
  &:hover{transform:translateY(-4px);box-shadow:0 30px 64px rgba(42,64,70,.26);background-size:105%;}
`;
const VacationTop = styled.span`position:absolute;top:18px;right:18px;left:18px;display:flex;align-items:center;justify-content:space-between;gap:8px;`;
const VacationEyebrow = styled.span`color:#f5c2ab;font-size:12px;font-weight:780;letter-spacing:.17em;`;
const VacationTag = styled.span`padding:6px 8px;color:#fff;background:rgba(31,53,59,.55);border:1px solid rgba(255,255,255,.22);border-radius:999px;backdrop-filter:blur(10px);font-size:12px;font-weight:740;letter-spacing:.11em;`;
const VacationTitle = styled.strong`max-width:330px;font-size:29px;font-weight:520;line-height:1.01;letter-spacing:-.045em;`;
const VacationCopy = styled.p`max-width:330px;margin:12px 0 18px;color:rgba(255,255,255,.78);font-size:12px;line-height:1.55;`;
const VacationAction = styled.span`display:flex;align-items:center;justify-content:space-between;padding-top:13px;border-top:1px solid rgba(255,255,255,.24);span{font-size:12px;font-weight:680;}small{display:block;margin-bottom:3px;color:#f0b59c;font-size:12px;letter-spacing:.15em;}b{display:grid;width:32px;height:32px;place-items:center;background:rgba(255,255,255,.13);border-radius:50%;font-size:15px;font-weight:500;}`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (max-width: 900px) {
    display: none;
  }
`;

const MobileActions = styled.div`
  display:none;
  @media(max-width:900px){display:flex;align-items:center;gap:8px;}
`;

const MobileHeaderPublish = styled.button`
  display:none;
  @media(max-width:900px){display:inline-flex;min-height:42px;align-items:center;justify-content:center;padding:0 15px;border:1px solid #c66f4e;border-radius:999px;background:#c66f4e;color:#fff;font:inherit;font-size:.8rem;font-weight:850;box-shadow:0 8px 18px rgba(198,111,78,.2);cursor:pointer;}
  @media(max-width:370px){padding:0 11px;font-size:.73rem;}
`;

const MobileMenuButton = styled.button`
  display: none;

  @media (max-width: 900px) {
    display: grid;
    place-items: center;
    width: 50px;
    height: 50px;
    padding: 0;
    border: 1px solid rgba(47,112,136,0.16);
    border-radius: 50%;
    background: rgba(234,242,243,0.82);
    color: #24353b;
    font-size: 28px;
    line-height: 1;
    cursor: pointer;
  }
`;

const MobileMenu = styled.nav`
  display: none;

  @media (max-width: 900px) {
    position: absolute;
    top: 82px;
    right: 0;
    left: 0;
    width: 100%;
    height: calc(100dvh - 82px);
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 20px 16px calc(32px + env(safe-area-inset-bottom));
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    background: #fcfbf8;
    z-index: 1900;
  }
`;

const MobileLink = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  padding: 12px 14px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #24353b;
  font: inherit;
  font-weight: 600;
  text-align: left;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background: #eaf2f3;
  }
`;

const MobilePrimaryLink = styled(MobileLink)`
  justify-content: center;
  min-height: 58px;
  margin-bottom: 2px;
  border-radius: 14px;
  background: #C66F4E;
  color: white;
  font-size: 16px;

  &:hover,
  &:focus-visible {
    background: #a8583e;
  }
`;

const MobileVacationLink = styled(MobileLink)`
  position:relative;display:block;min-height:118px;margin:2px 0;padding:20px 52px 20px 18px;color:#fff;background:#29474f;border-radius:14px;
  span,strong,small{display:block;}span{margin-bottom:7px;color:#f0a583;font-size:12px;font-weight:800;letter-spacing:.14em;}strong{font-size:20px;font-weight:620;line-height:1.18;}small{margin-top:7px;color:rgba(255,255,255,.68);font-size:12px;line-height:1.35;}svg{position:absolute;right:18px;top:50%;font-size:21px;transform:translateY(-50%);}
  &:hover,&:focus-visible{background:#34575f;}
`;

const MobileRichLink = styled(MobileLink)`
  display:flex;
  width:100%;
  min-height:72px;
  align-items:center;
  justify-content:space-between;
  gap:16px;
  padding:14px 16px;
  color:#263d43;
  background:#fff;
  text-decoration:none;
  border:1px solid rgba(41,71,79,.1);
  border-radius:14px;
  box-sizing:border-box;
  box-shadow:0 8px 28px rgba(41,71,79,.045);
  transition:background 180ms ease;
  &:hover,&:focus-visible{background:#eef3f1;}
  > span{min-width:0;}
  strong,small{display:block;}
  strong{color:#263d43;font-size:17px;font-weight:680;line-height:1.2;}
  small{margin-top:4px;color:#7b888a;font-size:12px;font-weight:480;line-height:1.35;}
  > svg{flex:0 0 auto;color:#bd6747;font-size:20px;}
`;

const MobileMenuCaption = styled.span`
  margin:7px 4px -5px;
  color:#a05a42;
  font-size:12px;
  font-weight:850;
  letter-spacing:.17em;
`;

const MobileSubLinks = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  padding: 8px;

  ${MobileLink} {
    min-height: 44px;
    justify-content: center;
    padding: 8px 6px;
    color: #68777b;
    background: #eef1ed;
    font-size: 12px;
  }
`;

const MobilePublish = styled.button`
  display:flex;
  width:100%;
  min-height:88px;
  align-items:center;
  justify-content:space-between;
  gap:14px;
  padding:16px 19px;
  color:#fff;
  background:linear-gradient(135deg,#c66f4e,#b85f40);
  border:1px solid #c66f4e;
  border-radius:16px;
  font:inherit;
  text-align:left;
  cursor:pointer;
  box-shadow:0 12px 26px rgba(184,95,64,.2);
  transition:transform .18s ease,box-shadow .18s ease;
  span{display:grid;gap:5px;min-width:0;}small{color:rgba(255,255,255,.72);font-size:.65rem;font-weight:850;letter-spacing:.12em;}strong{font-size:1.15rem;font-weight:800;}svg{flex:0 0 auto;font-size:24px;}&:hover,&:focus-visible{transform:translateY(-2px);box-shadow:0 16px 32px rgba(184,95,64,.28);}
`;

const MobileLogin = styled(MobilePrimaryLink)`
  margin-top: 12px;
`;

const MobileLogout = styled.button`
  min-height: 48px;
  padding: 12px 14px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #c0392b;
  font: inherit;
  font-weight: 600;
  text-align: left;
`;

const MobileDivider = styled.hr`
  width: 100%;
  margin: 10px 0;
  border: 0;
  border-top: 1px solid #ececec;
`;

const IconLink = styled(Link)`
  position: relative;
  display: grid;
  place-items: center;
  align-items: center;
  width: 46px;
  height: 46px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 50%;
  font-size: 1.6rem;
  color: #31464d;
  text-decoration: none;
  transition: color 200ms ease, background 200ms ease, border-color 200ms ease, transform 200ms ease;

  &:hover {
    background: #fff;
    border-color: rgba(47,112,136,0.16);
    color: #2f7088;
    transform: translateY(-2px);
  }

  &:hover span {
    opacity: 1;
    transform: translateY(0);
  }
`;

const HoverLabel = styled.span`
  position: absolute;
  top: 100%;
  margin-top: 6px;
  font-size: 12px;
  background: #24353b;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  transform: translateY(-4px);
  transition: all 0.2s ease;
`;

const PublishBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-height: 50px;
  margin-left: 10px;
  background: #C66F4E;
  color: white;
  padding: 0 22px;
  border-radius: 999px;
  font-weight: 600;
  font-size: 16px;
  border: none;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(163,84,57,0.18);
  transition: background 220ms ease, transform 220ms ease, box-shadow 220ms ease;

  &::after {
    content: '↗';
    font-size: 1.05em;
  }

  &:hover {
    background: #ad5d42;
    transform: translateY(-2px);
    box-shadow: 0 16px 34px rgba(163,84,57,0.24);
  }
`;

const LoginBtn = styled(Link)`
  position: relative;
  padding: 12px 10px;
  font-size: 1.18rem;
  font-weight: 600;
  text-decoration: none;
  color: #26383e;
  transition: color 180ms ease, transform 180ms ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    transform: translateY(-2px);
  }
`;

const MenuWrapper = styled.div`
  position: relative;
`;

const MenuButton = styled.button`
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  background: transparent;
  border: 0;
  border-radius: 50%;
  padding: 0;
  color: #29474f;
  font-size: 1.5rem;
  cursor: pointer;
  transition: background 180ms ease, color 180ms ease;

  &:hover,
  &[aria-expanded='true'] {
    color: #b85f40;
    background: rgba(184,95,64,.08);
  }
`;

const Dropdown = styled.div`
  position: absolute;
  top: 44px;
  right: 0;
  background: white;
  border-radius: 12px;
  min-width: 200px;
  padding: 12px;
  box-shadow: 0 16px 32px rgba(0,0,0,0.12);
  z-index: 2000;
`;

const DropdownLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 14px;
  color: #24353b;
  text-decoration: none;
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  font-size: 14px;
  background: none;
  border: none;
  color: #c0392b;
  cursor: pointer;
  width: 100%;
`;
